import { CardContainer, ContainerButton } from "./styles";

export const Card = ({ tech, deleteCard, openEditModal }) => {
  return (
    <CardContainer id={tech.id}>
      <h3>{tech.title}</h3>
      <p>{tech.status}</p>
      <ContainerButton>
        <button type="button" onClick={() => openEditModal()}>
          Edit
        </button>
        <button type="button" onClick={() => deleteCard(tech.id)}>
          X
        </button>
      </ContainerButton>
    </CardContainer>
  );
};
